import React from "react";
import { useHistory } from "react-router-dom";
//Material imports
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
// Limitless Components
import { useTranslation } from "@limitless/common/hooks";
import { Header, TimeSinceFooter } from "@limitless/customer/components";
import CreateMessageForm from "components/create-message-form/CreateMessageForm";
import Toast from "@limitless/customer/components/toast/Toast";
import { useCreateMessage } from "hooks/create-message-hook/CreateMessageHook";
import { useCustomerAutoSubmit } from "../hooks/customer-auto-submit/CustomerAutoSubmitHook";
import { useCustomerContext } from "@limitless/customer/hooks";

const useStyles = makeStyles({
    loadingContainer: {
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center"
    }
});

const CreateMessageScreen = () => {
    const { toggleAppOpen } = useCreateMessage();
    const { isReturningCustomer } = useCustomerContext();
    const history = useHistory();
    //evaluating is so we don't prematurely flash the history screen before the converation screen
    const { evaluating, autoSubmitLoading } = useCustomerAutoSubmit();
    const classes = useStyles();
    const { t } = useTranslation();

    React.useEffect(() => {
        //this would fire if it's been rehydrated - validates the user as a) our code could changed b) could've been manually changed
        if (!evaluating && !autoSubmitLoading && isReturningCustomer()) {
            history.push("/history");
        }
    }, [evaluating]);

    const isAutoSubmitting = evaluating || autoSubmitLoading;

    return (
        <div className="llm-view-container">
            <Header title="Get Help" onCloseHandle={toggleAppOpen} />
            <Toast />

            {isAutoSubmitting ? (
                <div className={classes.loadingContainer}>
                    <Typography>{t("Submitting question..")}</Typography>
                </div>
            ) : (
                <CreateMessageForm />
            )}
            <TimeSinceFooter />
        </div>
    );
};

export default CreateMessageScreen;
